import * as z from "zod";

export const createWorkOrderViewFolder = {
  name: "createWorkOrderViewFolder" as const,
  input: z.object({ name: z.string() }),
  output: z.object({ folderId: z.string() }),
};
